<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-card>
        <b-row>
          <b-col>
            <h4>{{ $dt('nav.employees_list_title', 'Employees') }}</h4>
          </b-col>
          <!-- <b-col md="auto">
            <b-button-group>
              <b-button v-if="!loading && list.actions && list.actions.create" class="mb-3" variant="primary" :to="{ name: 'LabelSetCreate' }">
                {{ $t('label_set.create_new') }}
              </b-button>
            </b-button-group>
          </b-col> -->
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <b-input-group>
                <b-form-input :placeholder="$t('global.search')" v-model="filters.search"></b-form-input>
                <b-input-group-append>
                  <b-button variant="primary" @click="getData()"><i class="fa fa-search" /></b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col md="auto">
            <b-form-group label-cols :label="$dt('global.per_page', 'Per page:')">
              <b-form-select :options="[2, 10, 20, 40, 60, 100, 500]" v-model="filters.per_page" />
            </b-form-group>
          </b-col>
          <b-col md="auto" v-if="listPaginator.last_page > 1">
            <Pagination :data="listPaginator" :limit="5" @pagination-change-page="onPageChange" />
          </b-col>
        </b-row>
        <b-row>
          <b-col><b-form-group><b-form-radio-group v-model="filters.active"
                :options="getBoolOptions($dt('employees.filters.active', 'Active'))"
                stacked></b-form-radio-group></b-form-group></b-col>
          <b-col><b-form-group><b-form-radio-group v-model="filters.enabled"
                :options="getBoolOptions($dt('employees.filters.enabled', 'Enabled'))"
                stacked></b-form-radio-group></b-form-group></b-col>
          <b-col><b-form-group><b-form-radio-group v-model="filters.plannable"
                :options="getBoolOptions($dt('employees.filters.plannable', 'Plannable'))"
                stacked></b-form-radio-group></b-form-group></b-col>
          <b-col><b-form-group><b-form-radio-group v-model="filters.plan_internal"
                :options="getBoolOptions($dt('employees.filters.plan_internal', 'Int. proj.'))"
                stacked></b-form-radio-group></b-form-group></b-col>
          <b-col><b-form-group><b-form-radio-group v-model="filters.rate_worklogs"
                :options="getBoolOptions($dt('employees.filters.rate_worklogs', 'Workl. top'))"
                stacked></b-form-radio-group></b-form-group></b-col>
          <!-- <b-col><b-form-group><b-form-checkbox v-model="filters.active" :value="1" :unchecked-value="0">{{$dt('employees.filters.active','Active')}}</b-form-checkbox></b-form-group></b-col> -->
          <!-- <b-col><b-form-group><b-form-checkbox v-model="filters.enabled" :value="1" :unchecked-value="0">{{$dt('employees.filters.enabled','Enabled')}}</b-form-checkbox></b-form-group></b-col>
          <b-col><b-form-group><b-form-checkbox v-model="filters.plannable" :value="1" :unchecked-value="0">{{$dt('employees.filters.plannable','Plannable')}}</b-form-checkbox></b-form-group></b-col>
          <b-col><b-form-group><b-form-checkbox v-model="filters.plan_internal" :value="1" :unchecked-value="0">{{$dt('employees.filters.plan_internal','Int. proj.')}}</b-form-checkbox></b-form-group></b-col>
          <b-col><b-form-group><b-form-checkbox v-model="filters.rate_worklogs" :value="1" :unchecked-value="0">{{$dt('employees.filters.rate_worklogs','Workl. top')}}</b-form-checkbox></b-form-group></b-col> -->
        </b-row>
        <NoDataView v-if="(!tableItems.length && !(loadingQueued || loading))" />
        <b-table v-else class="table-no-padding employee-table table-sm text-center" responsive outlined hover
          head-variant="light" :no-local-sorting=true :sort-by.sync="filters.sort_field" :sort-desc.sync="tableOrder"
          :fields="tableFields" :items="tableItems" :busy="(loading || loadingQueued)">
          <template #table-busy>
            <div class="text-center m-2"><b-spinner class="align-middle"></b-spinner></div>
          </template>
          <template v-slot:cell(displayName)="{ item }">
            <div>{{ item.displayName }}</div>
            <div class="email-badge">{{ item.email }}</div>
          </template>

          <template v-slot:cell(active)="{ value }"><b-checkbox :checked="value" disabled /></template>
          <template v-slot:cell(enabled)="{ value }"><b-checkbox :checked="value" disabled /></template>
          <template v-slot:cell(plannable)="{ value }"><b-checkbox :checked="value" disabled /></template>
          <template v-slot:cell(plan_internal)="{ value }"><b-checkbox :checked="value" disabled /></template>
          <template v-slot:cell(rate_worklogs)="{ value }"><b-checkbox :checked="value" disabled /></template>

          <template v-slot:cell(options)="{ item }">
            <router-link :to="{ name: 'EmployeeHome', params: { id_or_email: item.email || item.id } }">
              <i class="mx-1 fa fa-eye fa-lg" />
            </router-link>
            <router-link
              :to="{ name: 'EmployeeHome', params: { id_or_email: item.email || item.id, cat: 'employee_rates' } }"
              class="text-success">
              <i class="mx-1 fa fa-money fa-lg" />
            </router-link>
            <!-- <router-link :to="{ name: 'EmployeeForm', params:{ id: item.id  }}">
              <a><i class="mx-1 fa fa-eye fa-lg"/></a>
            </router-link> -->
            <!-- <div class="flex-container options-center">
            <router-link v-if="row.item.actions.view" :to="{ name: 'LabelSetSamples', params:{ project_id: row.item.project_id, label_set_id: row.item.id  }}">
              <a><i class="mx-1 fa fa-eye fa-lg"/></a>
            </router-link>
            <router-link v-if="row.item.actions.view" :to="{ name: 'LabelSetsCode'}">
              <a><i class="mx-1 fa fa-code fa-lg"/></a>
            </router-link>
            </div> -->
          </template>
        </b-table>
        <!--Paginator at bottom-->
        <div v-if="tableItems.length">
          <Pagination :data="listPaginator" :limit="5" @pagination-change-page="onPageChange" />
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import Pagination from 'laravel-vue-pagination';
import debounce from 'lodash.debounce';
import NoDataView from '@/views/Shared/NoDataView.vue';
import Services from '@/services/index';

const queryPrefix = null;
export default {
  mounted() {
    this.getData();
  },
  props: {},
  data() {
    return {
      tableFields: [
        // { key: 'id', sortable: true, label: this.$t('global.id') },
        { key: 'displayName', sortable: true, label: this.$dt('employee.displayName_email', 'Name / Email'), tdClass: 'text-left' },
        // { key: 'email', sortable: true, label: this.$dt('employee.email', 'Email'), tdClass: 'text-left' },
        { key: 'workload', sortable: true, label: this.$dt('employee.workload', 'Workload'), tdClass: 'text-right' },
        { key: 'active', sortable: false, label: this.$dt('employee.active', 'Active'), tdClass: 'text-center' },
        { key: 'enabled', sortable: false, label: this.$dt('employee.enabled', 'Enabled'), tdClass: 'text-center' },
        { key: 'plannable', sortable: false, label: this.$dt('employee.plannable', 'Plannable'), tdClass: 'text-center' },
        { key: 'plan_internal', sortable: false, label: this.$dt('employee.plan_internal', 'Int. proj.'), tdClass: 'text-center' },
        { key: 'rate_worklogs', sortable: false, label: this.$dt('employee.rate_worklogs', 'Workl. top'), tdClass: 'text-center' },
        { key: 'options', label: this.$dt('global.options', 'Options') }
      ],
      filters: this.parseQuery(),

      loading: false,
      loadingQueued: true,
      list: {},
    };
  },
  components: {
    Pagination, NoDataView
  },
  computed: {
    listPaginator() {
      return Object.is(this.list.meta, undefined) ? {} : this.list.meta;
    },
    tableItems() {
      return this.list.data || [];
    },
    params() {
      return {
        ...this.filters,
        // sort_order: this.filters.sort_order ? 'desc' : 'asc'
      };
    },
    tableOrder: {
      get() { return this.filters.sort_order === 'desc'; },
      set(value) {
        this.filters.sort_order = value
          ? 'desc' : 'asc';
      }
    },
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.loadingQueued = true;
        const hideFromRoute = []; // fixed filters
        this.$router.push({ query: this.uQuery(this.params, hideFromRoute, null, queryPrefix) })
          .catch(() => { /* redundant navigation exception */ });
        this.getData();
      }
    },
    '$route.query'() {
      this.filters = this.parseQuery();
      this.getData();
    },
  },
  methods: {
    getBoolOptions(text, textNot = null, textAny = null) {
      return [
        { text: textAny || 'Any', value: null },
        { text: text, value: 1 },
        { text: textNot || `Not ${text}`, value: 0 },
      ];
    },
    parseQuery() {
      const parsed = {
        page: this.uInt('page', 1, queryPrefix),
        sort_field: this.uStr('sort_field', 'displayName', queryPrefix),
        sort_order: this.uStr('sort_order', 'asc', queryPrefix),
        per_page: this.uInt('per_page', 20, queryPrefix),
        search: this.uStr('search', '', queryPrefix),

        active: this.uOpt('active', [null, 0, 1], 1, queryPrefix),
        enabled: this.uOpt('enabled', [null, 0, 1], 1, queryPrefix),
        plannable: this.uOpt('plannable', [null, 0, 1], null, queryPrefix),
        plan_internal: this.uOpt('plan_internal', [null, 0, 1], null, queryPrefix),
        rate_worklogs: this.uOpt('rate_worklogs', [null, 0, 1], null, queryPrefix),
      };
      return parsed;
    },
    // eslint-disable-next-line func-names
    getData: debounce(function () {
      this.loading = true;
      this.loadingQueued = false;
      Services.jira.employees({ params: this.params }).then(({ data }) => {
        this.list = data;
        if (this.filters.page !== 1 && data.data.length === 0) this.filters.page = 1; // If filters too strict
        this.loading = false;
      }).catch((err) => { this.loading = false; console.log(err); });
    }, 1000),

    onPageChange(page) {
      this.filters.page = page || 1; this.getData();
    },
  }
};
</script>
<style lang="scss">
.table-no-padding.table-sm {

  th,
  td {
    padding: 0 0.3rem;
  }
}

.employee-table td {
  vertical-align: middle;
}
</style>
<style scoped lang="scss">
.email-badge {
  color: $secondary;
  font-size: 0.7em;
  min-height: 1.6em;
}
</style>
